'use client';

import { useState } from 'react';
import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import SubscribeConsentDialog from './SubscribeConsentDialog';

export interface SubscribeBarProps extends HTMLAttributes<HTMLDivElement> {
  text?: ReactNode;
  buttonText?: ReactNode;
  background?: CSSProperties['background'];
  dialogTitle?: ReactNode;
  dialogContent?: ReactNode;
  dialogAgreeText?: string;
  dialogCancelText?: string;
}

/**
 * 订阅栏组件
 * 用于: 列表页、商品详情页、搜索结果页、优惠券页、购物车页
 */
const SubscribeBar = ({
  text = 'Missed a deal? Subscribe to never miss a discount again.',
  buttonText = 'Subscribe',
  background = '#F2F2F2',
  dialogTitle,
  dialogContent,
  dialogAgreeText,
  dialogCancelText,
  className,
  style,
  ...attrs
}: SubscribeBarProps) => {
  const [consentDialogVisible, setConsentDialogVisible] = useState(false);

  const openConsentDialog = () => {
    setConsentDialogVisible(true);
  };

  const barClassName = [
    // base
    'box-border flex w-full items-center font-br text-12 leading-[16px] text-[#333333]',
    // mobile
    'h-54 flex-nowrap justify-between gap-x-12 rounded-10 px-12 py-0',
    // pc
    'md:h-[80px] md:justify-center md:gap-x-[24px] md:rounded-[6px] md:px-[16px]',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const textClassName = [
    // mobile
    'min-w-0 flex-1 text-left text-12',
    // pc
    'md:flex-none md:text-center text-14',
  ].join(' ');

  const buttonClassName = [
    // base
    'cursor-pointer border-0 bg-[#282828] font-br text-white transition-opacity hover:opacity-90',
    // mobile
    'text-12 h-26 min-w-[82px] shrink-0 rounded-[13px] px-16 leading-[26px]',
    // pc
    'text-14 md:h-[32px] md:min-w-[123px] md:rounded-[16px] md:px-[18px] md:leading-[32px]',
  ].join(' ');

  return (
    <>
      <div {...attrs} className={barClassName} style={{ ...style, background }}>
        <span className={textClassName}>{text}</span>
        <button type="button" className={buttonClassName} onClick={openConsentDialog}>
          {buttonText}
        </button>
      </div>

      <SubscribeConsentDialog
        open={consentDialogVisible}
        onOpenChange={setConsentDialogVisible}
        title={dialogTitle}
        content={dialogContent}
        agreeText={dialogAgreeText}
        cancelText={dialogCancelText}
      />
    </>
  );
};

export default SubscribeBar;
